import { useEffect, useState } from "react"
import PetModal from "./pet-modal";

export default function MascotaCardComponent({ mascota }) {

  const [imageUrl, setImageUrl] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = () => {
    // console.log("iniciar", mascota);
    const imagenes = JSON.parse(mascota.imagenes);
    // console.log('imagenes', imagenes);
    if (Array.isArray(imagenes) === true && imagenes.length > 0) {
      setImageUrl(imagenes[0]);
    }
  };

  const render = () => {
    return (
      <>
        <a className="h-120 w-72 rounded shadow-lg mx-auto border border-palette-lighter mb-4"
          onClick={() => {
            //  console.log("show modal true"); 
            setShowModal(true);
          }}
        >

          {imageUrl === null &&
            <div className="h-72 border-b-2 border-palette-lighter relative overflow-hidden flex items-center justify-center">
              <svg
                className="w-16 h-16 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 7h18M3 12h18m-9 5h9"
                />
              </svg>
            </div>

          }
          {imageUrl !== null &&
            <div className="h-72 border-b-2 border-palette-lighter relative overflow-hidden">
              <img
                src={imageUrl}
                alt="mascota"
                className="absolute inset-0 w-full h-full object-cover transform duration-500 ease-in-out hover:scale-110"
              />
            </div>
          }

          <div className="h-48 relative">
            <div className="font-primary text-palette-primary text-2xl pt-4 px-4 font-semibold">
              {mascota.nombre}
            </div>
            <div className="text-lg text-gray-600 p-4 font-primary font-light">
              {mascota.raza}
            </div>
            <div
              className="text-palette-dark font-primary font-medium text-base absolute bottom-0 right-0 mb-4 pl-8 pr-4 pb-1 pt-2 bg-palette-lighter rounded-tl-sm triangle"
            >
              <label>{mascota.color}</label>
            </div>
          </div>
          {showModal &&
            <PetModal mascota={mascota}
              onClose={() => {
                setShowModal(false);
              }}
            />
          }
        </a>
      </>

    )
  };

  return render();

}
